import { render, staticRenderFns } from "./MobileCxMgmt.vue?vue&type=template&id=50331317&scoped=true&"
import script from "./MobileCxMgmt.vue?vue&type=script&lang=js&"
export * from "./MobileCxMgmt.vue?vue&type=script&lang=js&"
import style0 from "./MobileCxMgmt.vue?vue&type=style&index=0&id=50331317&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50331317",
  null
  
)

export default component.exports